module.exports = __webpack_public_path__ + "static/media/bard_male.e8ad52a7.png";